import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import * as _ from 'lodash';
import { __, getLocalized } from '../../../core/utils';
import {
  hideDropdown,
  showDropdown,
} from '../../../redux/actions/general/dropdown';
import { listProjectPlanningLibraryItems } from '../../../redux/actions/table/stages';
import SearchableDropdown from '../../../components/SearchableDropdown';
import styles from '../../../styles/views/company/PlanningTemplates.scss';

const ProjectPlanningLibraryDropdown = ({
  picker,
  projectId,
  languageId,
  onClose,
  onCreate,
}) => {
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const name = `project-planning-library-${picker.key}`;
  const typeLabel = __(`planning-templates.type.${picker.type}`);

  useEffect(() => {
    listProjectPlanningLibraryItems(projectId, picker.type).then(
      ({ response }) => {
        setItems(
          _.map(response.data, (item) => {
            const localizedName = getLocalized(item.name, languageId);

            return {
              ...item,
              value: item.id,
              label: item.code
                ? `${localizedName} · ${item.code}`
                : localizedName,
              is_company: !item.is_system,
              source_tooltip: item.is_system
                ? __('planning-templates.source.system')
                : __('planning-templates.source.my-company'),
            };
          }),
        );
      },
    );

    showDropdown(name);
  }, []);

  const selectItem = (item) => {
    setSelectedItems((currentItems) => [...currentItems, item]);
  };

  const removeItem = (item) => {
    setSelectedItems((currentItems) =>
      _.reject(currentItems, ({ id }) => id === item.id),
    );
  };

  const createItems = () => {
    if (_.isEmpty(selectedItems)) {
      onClose();
      return;
    }

    onCreate(selectedItems);
    hideDropdown();
  };

  return ReactDOM.createPortal(
    <div
      className={styles.libraryDropdownAnchor}
      style={{ left: picker.left, top: picker.top }}
    >
      <SearchableDropdown
        showSearchInput
        showIcon
        leftStyled
        multiselect
        top={4}
        name={name}
        options={items}
        selectedValues={_.map(selectedItems, 'id')}
        onSelect={selectItem}
        onRemove={removeItem}
        onButtonClick={createItems}
        buttonLabel={__('button.create')}
        dropdownContentClassName={styles.libraryDropdownContent}
        header={
          <div className={styles.libraryDropdownHeader}>
            <strong>
              {__('planning-templates.library-picker.title', {
                type: typeLabel,
              })}
            </strong>
            <span>
              {__('planning-templates.library-picker.subtitle', {
                type: typeLabel,
              })}
            </span>
          </div>
        }
      >
        <span />
      </SearchableDropdown>
    </div>,
    document.body,
  );
};

export default ProjectPlanningLibraryDropdown;
